import React from 'react';

import VgTags from '@vg/tags';

import { config } from '../../config';

const Tags = (props) => (
    <VgTags
        {...props}
        listHeading={config.tags.listHeading}
        listAriaHeading={config.tags.listAriaHeading}
    />
);

export default Tags;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Tags.js
 **/